export const sendEmailToSingleEmail = async (
  email,
  subject,
  htmlContent,
  name = ""
) => {
  try {
    // Validate inputs
    if (!email || !subject || !htmlContent) {
      console.error("Missing required fields: email, subject, or htmlContent");
      return false;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      console.error("Invalid email format:", email);
      return false;
    }

    // Fetch the Netlify function
    const response = await fetch("/.netlify/functions/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        subject,
        htmlContent,
      }),
    });

    // Check if response is OK
    if (!response.ok) {
      const text = await response.text(); // Get raw text to inspect non-JSON responses
      console.error(
        `Error sending email to ${email}: HTTP ${response.status}`,
        text
      );
      return false;
    }

    // Verify content type is JSON
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error(`Error: Non-JSON response from server:`, text);
      return false;
    }

    // Parse JSON response
    const result = await response.json();

    if (result.message === "Email sent successfully") {
      console.log(`Email sent successfully to ${email}`);
      return true;
    } else {
      console.error(
        `Error sending email to ${email}:`,
        result.error || "Unknown error"
      );
      return false;
    }
  } catch (error) {
    console.error(`Error sending email to ${email}:`, error.message);
    return false;
  }
};
